

































import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { CartItem } from '../../../store/modules/cart/types'

import { PluginMixin } from '../../../mixins/plugin'

@Component
export default class RemovedItem extends Mixins<PluginMixin>(PluginMixin) {
  @Prop()
  item: CartItem

  @Prop()
  restoreItem: () => any

  @Prop()
  isValid: boolean

  get isError(): boolean {
    return _.get(this.item, 'error.restore')
  }
}
